


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyBcwhXfPSd9aW--3nsYpUkkDsqbaA5y-EA",
  authDomain: "southern-eye-care.firebaseapp.com",
  projectId: "southern-eye-care",
  storageBucket: "southern-eye-care.firebasestorage.app",
  messagingSenderId: "842918463590",
  appId: "1:842918463590:web:53ec9fbe714871785fc5a7"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export